import React, { CSSProperties } from 'react';
import classnames from 'classnames';
import Icon, { IconProps } from 'src/modules/global/components/icon/Icon';

import styles from './BubbleIcon.module.scss';

export interface BubbleIconProps {
  className?: string;
  style?: CSSProperties;
  iconProps: IconProps;
  onClick?: () => void;
  onMouseOver?: () => void;
  onMouseOut?: () => void;
}

export const BubbleIcon = ({
  className,
  iconProps: { className: iconClassName, ...iconRestProps },
  style,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClick = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onMouseOver = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onMouseOut = () => {},
}: BubbleIconProps) => {
  return (
    <div
      style={style}
      className={classnames(styles.container, className)}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}>
      <Icon className={classnames(iconClassName, styles.icon)} {...iconRestProps} size="custom" />
    </div>
  );
};

export default BubbleIcon;
